/* 🤖 this file was generated by svg-to-ts*/
export const iconDocuments: {
  name: 'documents';
  data: string;
} = {
  name: 'documents',
  data: `<svg width="12" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M9 0H3a3 3 0 00-3 3v10a3 3 0 003 3h6a3 3 0 003-3V3a3 3 0 00-3-3zM2 13V3a1 1 0 011-1h6a1 1 0 011 1v7.78A2.95 2.95 0 006.78 14H3a1 1 0 01-1-1zm7 1h-.22A1 1 0 0110 12.78V13a1 1 0 01-1 1z" fill="currentColor" fill-rule="nonzero"/></svg>`,
};
